import type { MetaDescriptor } from "@remix-run/react";

interface ISeoProps {
  title: string;
  description: string;
  url: string;
  image?: string;
  notFound?: boolean;
}

export function getSeoMeta({
  title,
  description,
  url,
  image,
  notFound,
}: ISeoProps): MetaDescriptor[] {
  return notFound
    ? [
        { httpEquiv: "Status", content: "404 Not Found" },
        { title: "Page not found" },
        {
          name: "description",
          content: `Sorry, we’ve searched everywhere but still couldn’t find the page that you’re looking for.`,
        },
        { name: "robots", content: "noindex" },
      ]
    : [
        { title: title },
        { name: "description", content: description },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        { rel: "icon", href: "/favicon.ico" },

        // Open Graph meta tags
        { property: "og:type", content: "website" },
        { property: "og:url", content: url },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:image", content: image },

        // Twitter meta tags
        { property: "twitter:card", content: "summary_large_image" },
        { property: "twitter:url", content: url },
        { property: "twitter:title", content: title },
        { property: "twitter:description", content: description },
        { property: "twitter:image", content: image },
      ];
}
